// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Home_Home__1Rk9X {\n\t\n}\n", "",{"version":3,"sources":["webpack://src/components/Homepage/Home.module.css"],"names":[],"mappings":"AAAA;;AAEA","sourcesContent":[".Home {\n\t\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Home": "Home_Home__1Rk9X"
};
export default ___CSS_LOADER_EXPORT___;
